import { buildFileUrl } from '../apiConfig';
import {
  inferAttachmentMimeType,
  isImageMimeType,
  isVideoMimeType,
} from '../utils/fileAttachmentUtils';

function getFileNameFromUrl(url = '') {
  return url.split('/').pop() || 'فایل پیوست';
}

function stopPropagation(event) {
  event.stopPropagation();
}

function QuestionOptionFile({ url }) {
  if (!url) {
    return null;
  }

  const fileUrl = buildFileUrl(url);
  const fileName = getFileNameFromUrl(url);
  const mimeType = inferAttachmentMimeType({ url, originalName: fileName });

  if (isImageMimeType(mimeType)) {
    return (
      <div className="overflow-hidden rounded-[6px] bg-white" onClick={stopPropagation}>
        <img
          src={fileUrl}
          alt={fileName}
          className="mx-auto max-h-[180px] w-full object-contain"
        />
      </div>
    );
  }

  if (isVideoMimeType(mimeType)) {
    return (
      <div className="overflow-hidden rounded-[6px] bg-black" onClick={stopPropagation}>
        <video src={fileUrl} controls playsInline className="mx-auto max-h-[180px] w-full">
          مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
        </video>
      </div>
    );
  }

  return (
    <a
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation}
      className="rounded-[6px] bg-white/90 px-2 py-1 text-center text-[10px] font-semibold text-[#111827]"
    >
      مشاهده فایل پیوست
    </a>
  );
}

export default QuestionOptionFile;
